import { useTranslation } from 'react-i18next'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'

const ZipcodeValidationWarning = ({ showWarning }) => {
  const { t } = useTranslation()

  if (!showWarning) return null

  return <SDNotification type='warning' primaryText={t('subscriptionForm:offer_module.zipcodeWarning')} />
}

export default ZipcodeValidationWarning
